import React from 'react'
import { GoogleDriveSyncHistoryItem } from '../types'
import {
  SyncHistoryContainer,
  SyncHistoryItem,
  SyncHistoryStatus,
  SyncHistoryStats,
  EmptyState
} from '../style'

interface SyncHistoryPanelProps {
  history: GoogleDriveSyncHistoryItem[]
}

export const SyncHistoryPanel: React.FC<SyncHistoryPanelProps> = ({ history }) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return ''
    return new Date(dateString).toLocaleString()
  }

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'completed': return 'Completed'
      case 'failed': return 'Failed'
      case 'in_progress': return 'In Progress'
      case 'pending': return 'Pending'
      default: return status
    }
  }

  if (history.length === 0) {
    return (
      <SyncHistoryContainer>
        <EmptyState>No sync history yet</EmptyState>
      </SyncHistoryContainer>
    )
  }

  return (
    <SyncHistoryContainer>
      {history.map(item => (
        <SyncHistoryItem key={item.id}>
          <div>
            <SyncHistoryStatus status={item.status}>
              {getStatusLabel(item.status)}
            </SyncHistoryStatus>
            {item.errorMessage && (
              <div style={{ color: '#f44336', fontSize: '0.75rem', marginTop: '4px' }}>
                {item.errorMessage}
              </div>
            )}
          </div>
          <div style={{ textAlign: 'right' }}>
            <SyncHistoryStats>
              {item.filesAdded > 0 && `+${item.filesAdded} added `}
              {item.filesUpdated > 0 && `${item.filesUpdated} updated `}
              {item.filesSkipped > 0 && `${item.filesSkipped} skipped `}
              {item.filesFailed > 0 && `${item.filesFailed} failed`}
            </SyncHistoryStats>
            <div style={{ fontSize: '0.75rem', color: '#888', marginTop: '4px' }}>
              {formatDate(item.startedAt)}
            </div>
          </div>
        </SyncHistoryItem>
      ))}
    </SyncHistoryContainer>
  )
}
